import React from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import {
  Avatar,
  Cushion,
  FlexContainer,
  LinearGradient,
  Rectangle,
  Shadow,
  Space,
  Typography,
} from '@pitchero/react-ui';
import { Trans } from '../../lib/i18n';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import AvailabilityForm from './availability-form';

const AvailabilityPanel = ({ club, date, isActingOnSelf, member, note, onSubmit, status }) => (
  <Rectangle fill="white">
    <FlexContainer flexDirection="column" style={{ height: '100%' }}>
      <Rectangle fill="primary" component="div">
        <Cushion horizontal="large" top="large">
          <Space bottom="medium">
            <Typography align="center" color="primaryContrast" preset="title" component="div">
              <Trans i18nKey="common:availability_panel_title">Set availability</Trans>
            </Typography>
          </Space>
        </Cushion>
        <LinearGradient
          component="div"
          angle={0}
          stops={[
            [0, 'white'],
            ['50%', 'white'],
            ['50%', 'primary'],
          ]}
        >
          <Typography align="center" component="div">
            <Shadow shadow="dark">
              <Avatar image={member.avatar} alt={member.firstName} size={72} />
            </Shadow>
          </Typography>
        </LinearGradient>
      </Rectangle>

      <Cushion all="medium" style={{ flex: 1 }}>
        <FlexContainer flexDirection="column">
          <Space bottom="small">
            <Typography align="center" preset="tab--active" component="div" color="dustygrey">
              <Trans
                i18nKey={isActingOnSelf ? 'availability_prompt_self' : 'availability_prompt'}
                values={{ name: member.firstName }}
              >
                {`Are you available, ${member.firstName}?`}
              </Trans>
            </Typography>
          </Space>
          <Space bottom="medium">
            <Typography align="center" preset="subtitle--large" component="div">
              {DateTime.fromISO(date).setZone(club.timezone).toFormat('ccc d, LLLL yyyy')}
            </Typography>
          </Space>
          <AvailabilityForm status={status} note={note} onSubmit={onSubmit} />
        </FlexContainer>
      </Cushion>
    </FlexContainer>
  </Rectangle>
);

AvailabilityPanel.defaultProps = {
  note: null,
  status: null,
};

AvailabilityPanel.propTypes = {
  club: CLUB_PROP_TYPES.isRequired,
  date: PropTypes.string.isRequired,
  isActingOnSelf: PropTypes.bool.isRequired,
  member: PropTypes.shape({
    avatar: PropTypes.string,
    id: PropTypes.number,
    firstName: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  note: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  status: PropTypes.oneOf(['available', 'not_set', 'not_sure', 'unavailable']),
};

export default AvailabilityPanel;
